import {
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  RouteReuseStrategy,
} from '@angular/router'

const CACHEABLE_PATHS = new Set(['uploaded-files'])

export class TabRouteReuseStrategy implements RouteReuseStrategy {
  private cache = new Map<string, DetachedRouteHandle>()

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return this.isCacheable(route)
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    const key = this.getKey(route)
    if (key && handle) {
      this.cache.set(key, handle)
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const key = this.getKey(route)
    return !!(key && this.cache.has(key))
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const key = this.getKey(route)
    if (!key) {
      return null
    }
    return this.cache.get(key) ?? null
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot,
  ): boolean {
    return future.routeConfig === curr.routeConfig
  }

  private isCacheable(route: ActivatedRouteSnapshot): boolean {
    const path = route.routeConfig?.path
    return !!path && CACHEABLE_PATHS.has(path)
  }

  private getKey(route: ActivatedRouteSnapshot): string | null {
    const path = route.routeConfig?.path
    return path ? `reuse-${path}` : null
  }
}
